var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:['border-left', _vm.project.type.toLowerCase()]},[_c('h5',[_c('strong',[_vm._v(_vm._s(_vm.project.title))])]),(_vm.project.shortDescription)?_c('p',[_vm._v(_vm._s(_vm.project.shortDescription))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }